import { render, staticRenderFns } from "./SpendPoint.vue?vue&type=template&id=a22c335e&scoped=true"
import script from "./SpendPoint.vue?vue&type=script&lang=js"
export * from "./SpendPoint.vue?vue&type=script&lang=js"
import style0 from "./SpendPoint.vue?vue&type=style&index=0&id=a22c335e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22c335e",
  null
  
)

export default component.exports